/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import "./headline.module.css";

export const Headline = ({ content }) => {
  return <h1 styleName="headline" dangerouslySetInnerHTML={{ __html: content }} />;
};
